::ng-deep app-transaction-import-toolbar{flex:1 0 auto}
/*# sourceMappingURL=transaction-import-toolbar.component-XGN5YGN7.css.map */
